import React from "react";
import { Checkbox, Popconfirm } from "antd";
import { CaretUpOutlined, CaretDownOutlined } from "@ant-design/icons";
import { FlagSvg } from "./flag-svg";
import moment from "moment";

const checkFlag = (record) => {
  const {
    flag_odo_recognition_failed,
    flag_multi_date,
    flag_unavailable_vehicle,
    flag_changed_vehicle,
    flag_changed_km_norm,
    flag_changed_working_day,
    flag_created_manually,
  } = record;
  return (
    flag_odo_recognition_failed ||
    flag_multi_date ||
    flag_unavailable_vehicle ||
    flag_changed_vehicle ||
    flag_changed_km_norm ||
    flag_changed_working_day ||
    flag_created_manually
  );
};

export const handleMinutesToDate = (minutesData) => {
  if (minutesData === undefined || minutesData === null) {
    return "";
  }
  let hour = 0;
  let minutes = 0;
  hour = Math.floor(Number(minutesData) / 60);
  minutes = minutesData - hour * 60;
  return `${hour >= 10 ? hour : `0${hour}`}:${
    minutes >= 10 ? minutes : `0${minutes}`
  }`;
};

export const columns = (context) => [
  {
    title: "STT",
    dataIndex: "index",
    key: "index",
    fixed: true,
    className: "column-60 inherit-background",
    editable: false,
    render: (index, record) => {
      const { expandedRows } = context;
      const check = expandedRows.findIndex((value) => value === record.key);
      return (
        <span
          className="expand-container"
          onClick={() => {
            context.onExpand(record);
          }}
        >
          {record.children &&
            record.children.length > 0 &&
            (check !== -1 ? (
              <CaretUpOutlined className="expand-icon" />
            ) : (
              <CaretDownOutlined className="expand-icon" />
            ))}
          {index}
        </span>
      );
    },
  },
  {
    title: "Thứ",
    fixed: true,
    className: "column-80 inherit-background",
    dataIndex: "week_day", // should edit
    key: "week_day",
    editable: false,
  },
  {
    title: "Ngày",
    fixed: true,
    dataIndex: "date",
    key: "date",
    editable: false,
    className: "column-80 inherit-background",
    render: (date) => {
      return <div>{moment(date).format("DD/MM/YYYY")}</div>;
    },
  },
  {
    title: "Trạng thái",
    className: "column-150_status",
    dataIndex: "_", // should edit
    key: "_status",
    editable: false,
    render: (_, record) => {
      const {
        flag_odo_recognition_failed,
        flag_multi_date,
        flag_unavailable_vehicle,
        flag_changed_vehicle,
        flag_changed_km_norm,
        flag_changed_working_day,
        flag_created_manually,
        flag_finished_modify,
      } = record;
      return (
        <div
          style={{ display: "flex", alignItems: "center", flexWrap: "wrap" }}
        >
          {flag_odo_recognition_failed && (
            <FlagSvg color={"#ec3c39"} width={20} height={20} />
          )}
          {flag_multi_date && (
            <FlagSvg color={"#e9e23a"} width={20} height={20} />
          )}
          {flag_unavailable_vehicle && (
            <FlagSvg color={"#ab24d4"} width={20} height={20} />
          )}
          {flag_changed_vehicle && (
            <FlagSvg color={"#00a3f7"} width={20} height={20} />
          )}
          {flag_changed_km_norm && (
            <FlagSvg color={"#008726"} width={20} height={20} />
          )}
          {flag_changed_working_day && (
            <FlagSvg color={"#ec7c25"} width={20} height={20} />
          )}
          {flag_created_manually && (
            <FlagSvg color={"#e61592"} width={20} height={20} />
          )}
          {checkFlag(record) && flag_finished_modify === false && (
            <img
              onClick={() =>
                context.save({ ...record, flag_finished_modify: true }, true)
              }
              src={require("../../../../assets/icons/fixed.svg")}
              width={20}
              height={20}
            />
          )}
          {checkFlag(record) && flag_finished_modify === true && (
            <img
              onClick={() =>
                context.save({ ...record, flag_finished_modify: false }, true)
              }
              src={require("../../../../assets/icons/un-fixed.svg")}
              width={20}
              height={20}
            />
          )}
        </div>
      );
    },
  },
  {
    title: "Người sử dụng",
    className: "column-200",
    dataIndex: "customer_name_used",
    editable: true,
    key: "customer_name_used",
    inputType: "input-text",
    render: (list) => {
      return (
        <span>
          {list?.map((item, index) => {
            return (
              item && (
                <>
                  <span key={index} className="link-container">
                    {item}
                  </span>
                  <br />
                </>
              )
            );
          })}
        </span>
      );
    },
  },
  {
    title: "Bộ phận",
    dataIndex: "customer_department",
    key: "customer_department",
    className: "column-80",
    editable: true,
    inputType: "input-text",
    render: (list) => {
      return (
        <span>
          {list?.map((item, index) => {
            return (
              item && (
                <>
                  <span key={index} className="link-container">
                    {item}
                  </span>
                  <br />
                </>
              )
            );
          })}
        </span>
      );
    },
  },
  {
    title: "Hành trình chuyến đi",
    className: "column-300",
    dataIndex: "trip_itinerary",
    key: "trip_itinerary",
    inputType: "input-text",
    editable: true,
    render: (list) => {
      return (
        <span>
          {list?.map((item, index) => {
            return (
              item && (
                <>
                  <span key={index} className="link-container">
                    {item}
                  </span>
                  <br />
                </>
              )
            );
          })}
        </span>
      );
    },
  },
  {
    title: "Số km bắt đầu",
    dataIndex: "km_start",
    editable: true,
    key: "km_start",
    //className: 'column-80',
    isPercent: false,
    inputType: "input-number",
  },
  {
    title: "Số km khi đón khách",
    dataIndex: "km_customer_get_in",
    editable: true,
    isPercent: false,
    key: "km_customer_get_in",
    inputType: "input-number",
  },
  {
    title: "Số km khi trả khách",
    dataIndex: "km_customer_get_out",
    editable: true,
    isPercent: false,
    key: "km_customer_get_out",
    inputType: "input-number",
  },
  {
    title: "Số km kết thúc",
    dataIndex: "km_end",
    editable: true,
    key: "km_end",
    isPercent: false,
    inputType: "input-number",
  },
  {
    title: "Số km rỗng",
    dataIndex: "empty_km",
    editable: false,
    key: "empty_km",
    isPercent: false,
    inputType: "input-number",
  },
  {
    title: "Số km đã đi",
    dataIndex: "total_km",
    editable: false,
    key: "total_km",
    isPercent: false,
    inputType: "input-number",
  },
  {
    title: "Số km KH sử dụng (Có lái)",
    dataIndex: "used_km",
    editable: false,
    key: "used_km",
    isPercent: false,
    inputType: "input-number",
  },
  {
    title: "Số km KH sử dụng (Tự lái)",
    dataIndex: "used_km_self_drive",
    editable: false,
    key: "used_km_self_drive",
    isPercent: false,
    inputType: "input-number",
  },
  {
    title: "Thời gian làm việc (App)",
    className: "column-200",
    dataIndex: "app_work_time", // [working_time_app_from, working_time_app_to] // should edit
    editable: true,
    key: "app_work_time",
    inputType: "range-time",
    render: (app_work_time) => (
      <div>
        {app_work_time &&
          app_work_time?.map((value, index) => {
            let stringValue = "";
            if (value) {
              stringValue = moment(value, "HH:mm:ss").format("HH:mm");
            } else {
              stringValue = "-- : --";
            }
            if (index === 0) {
              stringValue = stringValue + " - ";
            }
            return stringValue;
          })}
      </div>
    ),
  },
  {
    title: "Thời gian làm việc (GPS)",
    className: "column-200",
    editable: true,
    dataIndex: "gps_work_time", // [working_time_gps_from, working_time_gps_to] // should edit
    key: "gps_work_time",
    inputType: "range-time",
    render: (gps_work_time) => (
      <div>
        {gps_work_time &&
          gps_work_time?.map((value, index) => {
            let stringValue = "";
            if (value) {
              stringValue = moment(value, "HH:mm:ss").format("HH:mm");
            } else {
              stringValue = "-- : --";
            }
            if (index === 0) {
              stringValue = stringValue + " - ";
            }
            return stringValue;
          })}
      </div>
    ),
  },
  {
    title: "Over time",
    dataIndex: "over_time",
    editable: false,
    key: "over_time",
    inputType: "input-number",
    isPercent: true,
    render: (data) => <span>{handleMinutesToDate(data)}</span>,
  },
  {
    title: "Over km có lái (Km)",
    dataIndex: "over_km",
    editable: false,
    key: "over_km",
    inputType: "input-number",
  },
  {
    title: "Over km tự lái (Km)",
    dataIndex: "over_km_self_drive",
    editable: false,
    key: "over_km_self_drive",
    inputType: "input-number",
  },
  {
    title: "Overnight (đêm)",
    dataIndex: "overnight",
    editable: true,
    key: "overnight",
    inputType: "input-number",
  },
  {
    title: "Ngày lễ",
    dataIndex: "is_holiday",
    editable: false,
    key: "is_holiday",
    render: (is_holiday) => <Checkbox disabled checked={is_holiday}></Checkbox>,
  },
  {
    title: "Cuối tuần",
    dataIndex: "is_weekend",
    key: "is_weekend",
    editable: true,
    inputType: "checkbox",
    render: (is_weekend) => <Checkbox disabled checked={is_weekend}></Checkbox>,
  },
  {
    title: "Có lái",
    dataIndex: "is_with_driver",
    key: "is_with_driver",
    editable: true,
    inputType: "checkbox",
    render: (is_with_driver) => (
      <Checkbox disabled checked={is_with_driver}></Checkbox>
    ),
  },
  {
    title: "Tự lái",
    dataIndex: "is_self_drive",
    key: "is_self_drive",
    editable: true,
    inputType: "checkbox",
    render: (is_self_drive) => (
      <Checkbox disabled checked={is_self_drive}></Checkbox>
    ),
  },
  {
    title: "Tài xế",
    dataIndex: "driver_name",
    editable: true,
    key: "driver_name",
    inputType: "input-text",
    render: (list) => {
      return (
        <span>
          {list?.map((item, index) => {
            return (
              item && (
                <>
                  <span key={index} className="link-container">
                    {item}
                  </span>
                  <br />
                </>
              )
            );
          })}
        </span>
      );
    },
  },
  {
    title: "Biển KS",
    dataIndex: "vehicle_number_plate",
    editable: true,
    key: "vehicle_number_plate",
    inputType: "input-text",
    render: (list) => {
      return (
        <span>
          {list?.map((item, index) => {
            return (
              item && (
                <>
                  <span key={index} className="link-container">
                    {item}
                  </span>
                  <br />
                </>
              )
            );
          })}
        </span>
      );
    },
  },
  {
    title: "Chi phí rửa xe (VNĐ)",
    className: "column-150",
    dataIndex: "CT010",
    editable: true,
    key: "CT010",
    inputType: "input-number",
    is_money: true,
    render: (value) => handleMoneyValue(value),
  },
  {
    title: "Chi phí đỗ xe (VNĐ)",
    className: "column-150",
    dataIndex: "CT008",
    editable: true,
    key: "CT008",
    inputType: "input-number",
    is_money: true,
    render: (value) => handleMoneyValue(value),
  },
  {
    title: "Chi phí săm lốp (VNĐ)",
    className: "column-150",
    dataIndex: "CT009",
    editable: true,
    key: "CT009",
    inputType: "input-number",
    is_money: true,
    render: (value) => handleMoneyValue(value),
  },
  {
    title: "Chi phí khác (VNĐ)",
    className: "column-150",
    dataIndex: "CT013",
    editable: true,
    key: "CT013",
    inputType: "input-number",
    is_money: true,
    render: (value) => handleMoneyValue(value),
  },
  {
    title: "Chi phí cầu đường (VNĐ)",
    className: "column-150",
    dataIndex: "CT007",
    editable: true,
    key: "CT007",
    inputType: "input-number",
    is_money: true,
    render: (value) => handleMoneyValue(value),
  },
  {
    title: "Danh sách chi phí cầu đường phát sinh",
    className: "column-200",
    dataIndex: "confirmation_screenshot",
    editable: false,
    key: "confirmation_screenshot",
    render: (links) => {
      if (!links) {
        return "";
      }
      return (
        <span>
          {links?.map((link, index) => {
            return (
              link && (
                <span className="link-container">
                  <a target="_blank" className="one-line-link" href={link}>
                    Link{index}
                  </a>
                  {index !== links.length - 1 ? ", " : ""}
                </span>
              )
            );
          })}
        </span>
      );
    },
  },
  {
    title: "Ảnh vé cầu đường",
    className: "column-200",
    dataIndex: "station_fee_images",
    editable: false,
    key: "station_fee_images",
    render: (links) => {
      if (!links) {
        return "";
      }
      return (
        <span>
          {links?.map((link, index) => {
            return (
              link && (
                <span className="link-container">
                  <a target="_blank" className="one-line-link" href={link}>
                    Link{index}
                  </a>
                  {index !== links.length - 1 ? ", " : ""}
                </span>
              )
            );
          })}
        </span>
      );
    },
  },
  {
    title: "Chi phí lưu đêm (VNĐ)",
    className: "column-150",
    dataIndex: "CT011",
    editable: true,
    key: "CT011",
    inputType: "input-number",
    is_money: true,
    render: (value) => handleMoneyValue(value),
  },
  {
    title: "Ảnh chi phí phát sinh",
    className: "column-200",
    dataIndex: "image_cost_links",
    editable: false,
    key: "image_cost_links",
    render: (links) => {
      if (!links) {
        return "";
      }
      return (
        <span>
          {links?.map((link, index) => {
            return (
              link && (
                <span className="link-container">
                  <a target="_blank" className="one-line-link" href={link}>
                    Link{index}
                  </a>
                  {index !== links.length - 1 ? ", " : ""}
                </span>
              )
            );
          })}
        </span>
      );
    },
  },
  {
    title: "Chi phí sự cố (VNĐ)",
    className: "column-150",
    dataIndex: "CT012",
    editable: true,
    key: "CT012",
    inputType: "input-number",
    is_money: true,
    render: (value) => handleMoneyValue(value),
  },
  {
    title: "Ảnh sự cố chuyến đi",
    className: "column-200",
    dataIndex: "image_breakdown_link",
    editable: false,
    key: "image_breakdown_link",
    render: (links) => {
      if (!links) {
        return "";
      }
      return (
        <span>
          {links?.map((link, index) => {
            return (
              link && (
                <span className="link-container">
                  <a target="_blank" className="one-line-link" href={link}>
                    Link{index}
                  </a>
                  {index !== links.length - 1 ? ", " : ""}
                </span>
              )
            );
          })}
        </span>
      );
    },
  },
  {
    title: "Ảnh ODO (Hệ thống không nhận dạng được)",
    className: "column-200",
    dataIndex: "image_odo_links",
    editable: false,
    key: "image_odo_links",
    render: (links) => {
      if (!links) {
        return "";
      }
      return (
        <span>
          {links?.map((link, index) => {
            return (
              link && (
                <span className="link-container">
                  <a target="_blank" className="one-line-link" href={link}>
                    Link{index}
                  </a>
                  {index !== links.length - 1 ? ", " : ""}
                </span>
              )
            );
          })}
        </span>
      );
    },
  },
  // {
  //   title: "Ảnh đón khách",
  //   className: "column-200",
  //   dataIndex: "image_customer_get_in_link",
  //   editable: false,
  //   key: "image_customer_get_in_link",
  //   render: (links) => {
  //     if (!links) {
  //       return "";
  //     }
  //     return (
  //       <span>
  //         {links?.map((link, index) => {
  //           return (
  //             link && (
  //               <span className="link-container">
  //                 <a target="_blank" className="one-line-link" href={link}>
  //                   Link{index}
  //                 </a>
  //                 {index !== links.length - 1 ? ", " : ""}
  //               </span>
  //             )
  //           );
  //         })}
  //       </span>
  //     );
  //   },
  // },
  // {
  //   title: "Ảnh trả khách",
  //   className: "column-200",
  //   dataIndex: "image_customer_get_out_link",
  //   editable: false,
  //   key: "image_customer_get_out_link",
  //   render: (links) => {
  //     if (!links) {
  //       return "";
  //     }
  //     return (
  //       <span>
  //         {links?.map((link, index) => {
  //           return (
  //             link && (
  //               <span className="link-container">
  //                 <a target="_blank" className="one-line-link" href={link}>
  //                   Link{index}
  //                 </a>
  //                 {index !== links.length - 1 ? ", " : ""}
  //               </span>
  //             )
  //           );
  //         })}
  //       </span>
  //     );
  //   },
  // },
  {
    title: "Trạng thái ký",
    className: "column-200",
    dataIndex: "signature_status",
    editable: false,
    key: "signature_status",
    render: (signature_status) => (
      <span>
        {signature_status === true
          ? "Đã ký"
          : signature_status === false
          ? "Chưa ký"
          : ""}
      </span>
    ),
  },
  {
    title: "Ảnh chữ ký",
    className: "column-200",
    dataIndex: "signature_image_url",
    editable: false,
    key: "signature_image_url",
    render: (links) => {
      if (!links) {
        return "";
      }
      return (
        <span>
          {links?.map((link, index) => {
            return (
              link && (
                <span className="link-container">
                  <a target="_blank" className="one-line-link" href={link}>
                    Link{index}
                  </a>
                  {index !== links.length - 1 ? ", " : ""}
                </span>
              )
            );
          })}
        </span>
      );
    },
  },
  {
    title: "Nhận xét",
    className: "column-200",
    dataIndex: "signature_comment",
    editable: false,
    key: "signature_comment",
    render: (list) => {
      return list?.map((item, index) => {
        return item && <div key={index}>{item}</div>;
      });
    },
  },
  {
    title: "Ghi chú",
    className: "column-200 noteMW",
    dataIndex: "note",
    editable: true,
    key: "note",
    render: (list) => {
      return list?.map((item, index) => {
        return item && <div key={index}>{item}</div>;
      });
    },
  },
  {
    title: "",
    dataIndex: "operation",
    key: "operation",
    render: (_, record) => {
      const editable = context.isEditing(record);
      const lockEdit =
        context.props.lockTime >=
        moment(context.state.date.start).startOf("month").valueOf()
          ? true
          : false;

      return editable ? (
        <span>
          <a
            disabled={context.state.buttonDisable}
            onClick={() => context.save(record)}
            style={styles.mr8}
          >
            Lưu
          </a>
          <Popconfirm
            overlayClassName="white-pupop"
            cancelText="Huỷ"
            okText={"Chấp nhận"}
            title="Bạn có chắc chắn muốn huỷ?"
            onConfirm={context.cancel}
          >
            <a style={styles.mr8}>Huỷ</a>
          </Popconfirm>
          {!record.journey_diary_id && record.flag_created_manually ? (
            <Popconfirm
              overlayClassName="white-pupop"
              cancelText="Huỷ"
              okText={"Chấp nhận"}
              title="Bạn có chắc chắn muốn xoá?"
              onConfirm={() => context.delete(record)}
            >
              <a>Xoá</a>
            </Popconfirm>
          ) : null}
        </span>
      ) : record.children !== undefined ? (
        <span>
          {record.children.length === 0 && (
            <a
              disabled={context.state.editingKey !== "" || lockEdit}
              style={styles.mr8}
              onClick={() => {
                context.edit(record);
              }}
            >
              Sửa
            </a>
          )}
          {record.km_start !== undefined &&
            record.km_start !== null &&
            !record.journey_diary_id &&
            record.flag_created_manually && (
              <Popconfirm
                disabled={context.state.editingKey !== "" || lockEdit}
                overlayClassName="white-pupop"
                cancelText="Huỷ"
                okText={"Chấp nhận"}
                title="Bạn có chắc chắn muốn xoá?"
                onConfirm={() => context.delete(record)}
              >
                <a
                  disabled={context.state.editingKey !== "" || lockEdit}
                  style={styles.mr8}
                >
                  Xoá
                </a>
              </Popconfirm>
            )}
          {record.km_start !== undefined && record.km_start !== null && (
            <a
              disabled={context.state.editingKey !== "" || lockEdit}
              onClick={() => context.add(record)}
            >
              Thêm
            </a>
          )}
        </span>
      ) : (
        <span>
          <a
            style={styles.mr8}
            disabled={context.state.editingKey !== "" || lockEdit}
            onClick={() => {
              context.edit(record);
            }}
          >
            Sửa
          </a>
          {!record.journey_diary_id && record.flag_created_manually ? (
            <Popconfirm
              overlayClassName="white-pupop"
              cancelText="Huỷ"
              okText={"Chấp nhận"}
              title="Bạn có chắc chắn muốn xoá?"
              onConfirm={() => context.delete(record)}
            >
              <a disabled={context.state.editingKey !== "" || lockEdit}>Xoá</a>
            </Popconfirm>
          ) : null}
        </span>
      );
    },
  },
];

export const formValidate = (field, inputType, record, contractType) => {
  let validate = [];
  if (inputType === "input-number") {
    switch (field) {
      case "km_start":
        validate = [
          ({ getFieldValue }) => ({
            validator(rule, v) {
              const km_customer_get_out = getFieldValue("km_start");
              const km_customer_get_in = getFieldValue("km_customer_get_in");
              const km_end = getFieldValue("km_end");
              if (contractType === 1) {
                if (v === null || v === undefined) {
                  return Promise.reject(`Bắt buộc!`);
                }
                if (Number(v) > 9999999) {
                  return Promise.reject(`Giá trị <= 7 chữ số!`);
                }
                if (Number(v) > Number(km_customer_get_out)) {
                  return Promise.reject(`Số km > km trả khách`);
                }
                if (Number(v) > Number(km_customer_get_in)) {
                  return Promise.reject(`Số km > km đón khách`);
                }
                if (Number(v) > Number(km_end)) {
                  return Promise.reject(`Số km > km kết thúc`);
                }
                return Promise.resolve();
              } else {
                if (v === null || v === undefined || v === 0) {
                  return Promise.reject(`Bắt buộc!`);
                }
                if (Number(v) > 9999999) {
                  return Promise.reject(`Giá trị <= 7 chữ số!`);
                }
                return Promise.resolve();
              }
            },
          }),
        ];
        break;

      case "km_customer_get_in":
        validate = [
          ({ getFieldValue }) => ({
            validator(rule, v) {
              const km_start = getFieldValue("km_start");
              const km_customer_get_out = getFieldValue("km_customer_get_out");
              const km_end = getFieldValue("km_end");
              if (v === null || v === undefined) {
                return Promise.reject(`Bắt buộc!`);
              }
              if (Number(v) > 9999999) {
                return Promise.reject(`Giá trị <= 7 chữ số!`);
              }
              if (Number(v) < Number(km_start)) {
                return Promise.reject(`Số km < km bắt đầu`);
              }
              if (Number(v) > Number(km_customer_get_out)) {
                return Promise.reject(`Số km > km trả khách`);
              }
              if (Number(v) > Number(km_end)) {
                return Promise.reject(`Số km > km kết thúc`);
              }
              return Promise.resolve();
            },
          }),
        ];
        break;

      case "km_customer_get_out":
        validate = [
          ({ getFieldValue }) => ({
            validator(rule, v) {
              const km_start = getFieldValue("km_start");
              const km_customer_get_in = getFieldValue("km_customer_get_in");
              const km_end = getFieldValue("km_end");
              if (v === null || v === undefined) {
                return Promise.reject(`Bắt buộc!`);
              }
              if (Number(v) > 9999999) {
                return Promise.reject(`Giá trị <= 7 chữ số!`);
              }
              if (Number(v) < Number(km_start)) {
                return Promise.reject(`Số km < km bắt đầu`);
              }
              if (Number(v) < Number(km_customer_get_in)) {
                return Promise.reject(`Số km < km đón khách`);
              }
              if (Number(v) > Number(km_end)) {
                return Promise.reject(`Số km > km kết thúc`);
              }
              return Promise.resolve();
            },
          }),
        ];
        break;

      case "km_end":
        validate = [
          ({ getFieldValue }) => ({
            validator(rule, v) {
              const km_start = getFieldValue("km_start");
              const km_customer_get_in = getFieldValue("km_customer_get_in");
              const km_customer_get_out = getFieldValue("km_end");
              if (v === null || v === undefined) {
                return Promise.reject(`Bắt buộc!`);
              }
              if (Number(v) > 9999999) {
                return Promise.reject(`Giá trị <= 7 chữ số!`);
              }
              if (Number(v) < Number(km_start)) {
                return Promise.reject(`Số km < km bắt đầu`);
              }
              if (Number(v) < Number(km_customer_get_in)) {
                return Promise.reject(`Số km < km đón khách`);
              }
              if (Number(v) < Number(km_customer_get_out)) {
                return Promise.reject(`Số km < km trả khách`);
              }
              return Promise.resolve();
            },
          }),
        ];
        break;

      default:
        validate = [
          ({ getFieldValue }) => ({
            validator(rule, v) {
              if (v !== undefined && v !== null && v.toString().length > 11) {
                return Promise.reject(`Giá trị <= 11 chữ số!`);
              }
              return Promise.resolve();
            },
          }),
        ];
        break;
    }
  } else {
    if (field === "note") {
      // validate = [{
      //   max: 500,
      //   message: 'Ghi chú phải < 500 kí tự'
      // }]
      validate = [
        ({ getFieldValue }) => ({
          validator(rule, v) {
            if (v.length > 500) {
              return Promise.reject("Ghi chú phải < 500 kí tự");
            }
            return Promise.resolve();
          },
        }),
      ];
    } else if (field === "vehicle_number_plate") {
      validate = [
        ({ getFieldValue }) => ({
          validator(rule, v) {
            if (!v || !v.toString()) {
              return Promise.reject(`Bắt buộc!`);
            }
            if (!/[A-Z0-9]*-[A-Z0-9]*/.test(v)) {
              return Promise.reject("Sai định dạng!");
            }
            return Promise.resolve();
          },
        }),
      ];
    } else if (
      field === "driver_name" ||
      field === "customer_name_used" ||
      field === "trip_itinerary"
    ) {
      validate = [
        ({ getFieldValue }) => ({
          validator(rule, v) {
            const is_self_drive = getFieldValue("is_self_drive");
            if (!is_self_drive && (!v || !v.toString())) {
              return Promise.reject(`Bắt buộc!`);
            }
            return Promise.resolve();
          },
        }),
      ];
    } else if (field === "gps_work_time" || field === "app_work_time") {
      validate = [
        ({ getFieldValue }) => ({
          validator(rule, v) {
            if (v.length < 2 || (v.length === 2 && (!v[0] || !v[1]))) {
              return Promise.reject(`Bắt buộc!`);
            }
            if (
              v.length >= 2 &&
              v[0] &&
              v[1] &&
              v[0].valueOf() > v[1].valueOf()
            ) {
              return Promise.reject(`Thời gian bắt đầu phải nhỏ hơn kết thúc`);
            }
            return Promise.resolve();
          },
        }),
      ];
    }
  }

  return validate;
};

const styles = {
  mr8: {
    marginRight: 8,
  },
};

export const initFormValue = {
  customer_name_used: [],
  customer_department: [],
  trip_itinerary: [],
  km_start: 0,
  km_customer_get_in: 0,
  km_customer_get_out: 0,
  km_end: 0,
  empty_km: 0,
  total_km: 0,
  used_km: 0,
  used_km_self_drive: 0,
  app_work_time: [],
  gps_work_time: [],
  over_time: 0,
  over_km: 0,
  overnight: 0,
  is_self_drive: false,
  is_with_driver: false,
  vehicle_number_plate: [],
  CT010: 0,
  CT009: 0,
  CT013: 0,
  CT007: 0,
  CT008: 0,
  CT011: 0,
  CT012: 0,
  overnight: 0,
  note: [],
  driver_name: [],
  is_weekend: false,
};

// follow app

export const enableEdit = (field) => {
  switch (field) {
    case "customer_name_used":
    case "customer_department":
    case "gps_work_time":
    case "km_start":
    case "km_customer_get_in":
    case "km_customer_get_out":
    case "km_end":
    case "CT010":
    case "CT008":
    case "CT009":
    case "CT013":
    case "CT007":
    case "CT011":
    case "CT012":
    case "note":
    case "overnight":
    case "driver_name":
    case "vehicle_number_plate":
      return true;

    default:
      return false;
  }
};

// add from web journey diary self drive

export const enableEditFolowWebSelfDrive = (field) => {
  switch (field) {
    case "km_start":
    case "km_customer_get_in":
    case "km_customer_get_out":
    case "km_end":
    case "CT010":
    case "CT008":
    case "CT009":
    case "CT013":
    case "CT007":
    case "CT011":
    case "CT012":
    case "note":
    case "customer_name_used":
    case "customer_department":
    case "trip_itinerary":
    case "vehicle_number_plate":
    case "is_self_drive":
    case "is_with_driver":
    case "gps_work_time":
      return true;

    default:
      return false;
  }
};

export const enableEditFolowWeb = (field) => {
  switch (field) {
    case "km_start":
    case "km_customer_get_in":
    case "km_customer_get_out":
    case "km_end":
    case "CT010":
    case "CT008":
    case "CT009":
    case "CT013":
    case "CT007":
    case "CT011":
    case "CT012":
    case "note":
    case "customer_name_used":
    case "customer_department":
    case "trip_itinerary":
    case "vehicle_number_plate":
    case "is_self_drive":
    case "is_with_driver":
    case "gps_work_time":
    case "driver_name":
    case "overnight":
      return true;

    default:
      return false;
  }
};

export const enableEditFolowKmStartEnd = (field) => {
  switch (field) {
    case "km_start":
    case "km_end":
    case "note":
      return true;

    default:
      return false;
  }
};

export const enableEditFolowKmEnd = (field) => {
  switch (field) {
    case "km_end":
    case "note":
      return true;

    default:
      return false;
  }
};

export const enableEditFolowKmStart = (field) => {
  switch (field) {
    case "km_start":
    case "note":
      return true;

    default:
      return false;
  }
};

export const enableEditFolowNote = (field) => {
  switch (field) {
    case "note":
      return true;

    default:
      return false;
  }
};

export const convertCosts = (costs) => {
  let jsonCost = {};
  costs.forEach((cost) => {
    jsonCost[cost.code] = cost.value;
  });
  return jsonCost;
};

export const handleMoneyValue = (money) => {
  if (money === undefined || money === null) {
    return "";
  }
  return money.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const handleSubmitValue = (values, record) => {
  let costs = [];
  const costRecord = record.costs;
  keys.forEach((key) => {
    let id = null;
    if (costRecord) {
      const findIndex = costRecord.findIndex((cost) => cost.code === key);
      if (findIndex !== -1) {
        id = costRecord[findIndex].id;
      }
    }
    costs.push({
      code: key,
      id: id,
      value:
        values[key] !== undefined && values[key] !== null
          ? values[key]
          : record[key] !== undefined && record[key] !== null
          ? record[key]
          : 0,
    });
  });
  const { app_work_time, gps_work_time } = values;
  const note =
    typeof values.note === "object" ? values.note.join() : values.note;
  let trip_itinerary = record.trip_itinerary;
  let vehicle_number_plate = record.vehicle_number_plate;
  let driver_name = record.driver_name;
  let customer_department = record.customer_department;
  let customer_name_used = record.customer_name_used;
  if (values.trip_itinerary) {
    trip_itinerary = values.trip_itinerary;
  }
  if (values.vehicle_number_plate) {
    vehicle_number_plate = values.vehicle_number_plate;
  }
  if (values.driver_name) {
    driver_name = values.driver_name;
  }
  if (values.customer_department) {
    customer_department = values.customer_department;
  }
  if (values.customer_name_used) {
    customer_name_used = values.customer_name_used;
  }
  return {
    ...record,
    ...values,
    costs,
    overnight: Object.keys(values).length
      ? values.overnight
        ? values.overnight
        : 0
      : record.overnight
      ? record.overnight
      : 0,
    trip_itinerary:
      typeof trip_itinerary === "string"
        ? trip_itinerary
        : trip_itinerary.length > 0
        ? trip_itinerary[0]
        : "",
    vehicle_number_plate:
      typeof vehicle_number_plate === "string"
        ? vehicle_number_plate.trim()
        : vehicle_number_plate.length > 0
        ? vehicle_number_plate[0]
        : "",
    driver_name:
      typeof driver_name === "string"
        ? driver_name
        : driver_name.length > 0
        ? driver_name[0]
        : "",
    customer_department:
      typeof customer_department === "string"
        ? customer_department
        : customer_department.length > 0
        ? customer_department[0]
        : "",
    customer_name_used:
      typeof customer_name_used === "string"
        ? customer_name_used
        : customer_name_used.length > 0
        ? customer_name_used[0]
        : "",
    working_time_app_from: app_work_time
      ? app_work_time[0]
      : record.app_work_time
      ? record.app_work_time[0]
      : null,
    working_time_app_to: app_work_time
      ? app_work_time[1]
      : record.app_work_time
      ? record.app_work_time[1]
      : null,
    working_time_gps_from: gps_work_time
      ? gps_work_time[0]
      : record.gps_work_time
      ? record.gps_work_time[0]
      : null,
    working_time_gps_to: gps_work_time
      ? gps_work_time[1]
      : record.gps_work_time
      ? record.gps_work_time[1]
      : null,
    note: Object.keys(values).length
      ? note
      : record.note && record.note.length > 0
      ? record.note[0]
      : null,
    // note && note.length > 0 ? note : (record.note && record.note.length > 0 ? record.note[0] : null),
  };
};

const keys = ["CT007", "CT008", "CT009", "CT010", "CT011", "CT012", "CT013"];

export const kmDependencies = [
  "km_start",
  "km_customer_get_in",
  "km_customer_get_out",
  "km_end",
];
